var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-dialog",
    {
      attrs: {
        visible: _vm.visible,
        closable: false,
        "empty-header": "",
        top: "8vh",
        width: "850px",
      },
      on: { close: _vm.skip },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("ib-divider", { staticClass: "mb-4", attrs: { block: "" } }),
              _c("ib-dialog-footer", {
                attrs: {
                  "button-size": "md",
                  "submit-btn-text": _vm.$t("upgradeToContinue"),
                  "cancel-btn-text": _vm.$t("back"),
                  "visible-submit-btn":
                    _vm.subscriptionIsDreamer || _vm.subscriptionIsFreeTrial,
                },
                on: { submit: _vm.submit, cancel: _vm.skip },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [_c("business-plan-quick-tour", { attrs: { "video-height": "250" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }